export default __webpack_public_path__ + "static/Urbain3-79c7e8734c62cbf9f5277ab4a520b3da.svg";